module.exports = __webpack_public_path__ + "img/bunnings-logo.f593c758.png";